/* eslint-disable no-mixed-spaces-and-tabs */
/**
 * 我是上帝
 * 上帝只有一个，所以是单例。
 * 上帝是无所不知，所以不论你想知道什么都可以问上帝。
 * 你无需告诉上帝，所以没有set方法。
 * 如果想让上帝保佑你，请敞开你的心扉，通过delegate的方法暴露你的state或者store
 */
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { OnlineEditServices } from '@src/slide/domain/slide-app/scenes/online/core/online-edit-services.core';
import { SlideFile } from '@tencent/slide-sdk-model';
import { CommandData } from '@tencent/slide-sdk-model/src/app/command-data';
import { RevisionData } from '@tencent/slide-sdk-model/src/app/revision-data';
import { TransformRequestData, TransformResponseData } from '@tencent/slide-sdk-model/src/app/wasm-data';
import CommonTips from '@src/framework/frame/components/common-tips';
import { OfflineEditServices } from '@src/slide/domain/slide-app/scenes/offline/core/offline-edit-service.core';
declare global {
    interface Window {
        pray: any;
    }
}
// 以后，通过祈祷，就可以和上帝对话了
window.pray = (): God => God.myGod();

export default class God {
    private static __singletonRef: God;
    static myGod() {
        if (!God.__singletonRef) {
            God.__singletonRef = new God();
        }
        return God.__singletonRef;
    }

    // delegate
    private _getManagerState: Function;
    // delegate
    private _getPlayRoomManagerState: Function;
    private _playerStore: any;
    /**
	 * 上帝保佑Manager
	 * 提供可以访问Manager state的方法
	 */
    blessManager(getState: Function) {
        this._getManagerState = getState;
    }

    /**
	 * 上帝保佑Manager
	 * 提供可以访问PlayRoom Manager state的方法
	 */
    blessPlayRoomManager(getState: Function) {
        this._getPlayRoomManagerState = getState;
    }

    /**
	 * 是否正在进行PPT播放
	 */
    public get isPlaying(): boolean {
        const appService = AppServiceProvider.getInstance().getAppServices() as IEditorAppServices;
        return appService.viewableServiceLayer.playManager.isPlaying;
    }

    /**
     * 在线预览公共能力支持
     * 挂在 pray 方便调试
     */
    public get openClientApiManager() {
        const appService = AppServiceProvider.getInstance().getAppServices() as IEditorAppServices;
        return appService.viewableServiceLayer.openClientApiManager;
    }

    public get SlideAppV3(): any {
        return {
            SlideDataServices,
            OnlineEditServices,
        };
    }

    public get _() {
        return {
            SlideDataServices,
            OnlineEditServices,
            Collaboration: OnlineEditServices.CollaborationManager(),
            CommandManager: SlideDataServices.SDKDataServices.CommandManager(),
            PresentationStore: SlideDataServices.SDKDataServices.PresentationStoreService(),
            Presentation: SlideDataServices.SDKDataServices.PresentationStoreService()?.getPresentation(),
            SlideFile,
            CommandData,
            RevisionData,
            TransformRequestData,
            TransformResponseData,
            CommonTips: CommonTips.getInstance(),
            OfflineEditServices,
        };
    }


    // /**
    //  * 获得Player的store对象
    //  * TODO 这里暴露的太粗放了，应该通过更具体的方法获得状态。
    // //  */
    // public get playerStore(): any{
    //     if (!this._playerStore) {
    //         // import(/* webpackChunkName: "afterFirstPaint" */ '../../framework/player/src/store').then((module)=>{
    //         //     this._playerStore = module.default;
    //         // });
    //     }
    // 	return this._playerStore;
    // }

    // /**
    //  * 获得播放的当前页。
    //  * TODO 先屏蔽掉，在这里即使动态import也编译到主包里了，ts的问题？
    //  */
    // currentPlayPage(): number{
    //     if (!this._playerStore) {
    //         import(/* webpackChunkName: "afterFirstPaint" */ '../../framework/player/src/store').then((module)=>{
    //             this._playerStore = module.default;
    //         });
    //     }
    // 	let state = this._playerStore && this._playerStore.getState();
    // 	let page = state && state.control && state.control.currentPage || 0;
    // 	return page;
    // }

    public get pptTitle(): string {
        const clientVars = SlideDataServices.ClientVarsService()?.getClientVars() || {};
        return clientVars.title || clientVars.padTitle || '';
    }
    public get revision(): number {
        const clientVars = SlideDataServices.ClientVarsService()?.getClientVars() || {};
        return clientVars.collab_client_vars?.rev || 0;
    }
    /**
	 * 获得当前的编辑页
	 */
    public get editorCurrentSlideIndex(): number {
        const selectionService = this.getSelectionService();
        if (selectionService) {
            return selectionService.currentSlideIndex;
        }
        return -1;
    }

    /**
	 * 获得图片上传的操作位置
	 */
    public get editorlastInsertButtonClickType(): number {
        const appService = AppServiceProvider.getInstance().getAppServices() as IEditorAppServices;
        return appService?.viewableServiceLayer?.toolbarStateManager.lastInsertButtonClick;
    }

    private getSelectionService(): ISelectionService | undefined {
        const appService = AppServiceProvider.getInstance().getAppServices() as IEditorAppServices;
        if (appService?.viewableServiceLayer?.selectionService) {
            return appService.viewableServiceLayer.selectionService;
        }
        return undefined;
    }
}
